import { $ } from './dom';

let toastTimer: ReturnType<typeof setTimeout> | undefined;

export function showToast(msg: string): void {
  const el = $('toast');
  el.textContent = msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('show'), 1500);
}
